import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'

const OfflineNavActionsContext = createContext(null)

/**
 * @typedef {Object} OfflineNavActions
 * @property {(scope?: 'all' | 'new_only') => void} onExport
 * @property {(() => void) | undefined} onImportZip
 * @property {boolean} [importZipBusy]
 * @property {boolean} [isOnline]
 */

export function OfflineNavActionsProvider({ children }) {
  const [actions, setActions] = useState(null)

  const register = useCallback((next) => {
    setActions(next)
  }, [])

  const value = useMemo(() => ({ actions, register }), [actions, register])

  return (
    <OfflineNavActionsContext.Provider value={value}>
      {children}
    </OfflineNavActionsContext.Provider>
  )
}

/** @returns {OfflineNavActions | null} */
export function useOfflineNavActions() {
  const ctx = useContext(OfflineNavActionsContext)
  return ctx?.actions ?? null
}

/**
 * Registra azioni export/import da Home (o altra pagina) per il menu desktop.
 * @param {OfflineNavActions | null} actions
 */
export function useRegisterOfflineNavActions(actions) {
  const ctx = useContext(OfflineNavActionsContext)

  useEffect(() => {
    if (!ctx) return undefined
    ctx.register(actions)
    return () => ctx.register(null)
  }, [
    ctx,
    actions,
    actions?.onExport,
    actions?.onImportZip,
    actions?.importZipBusy,
    actions?.isOnline,
  ])
}
